import { EmptyState, NoDataIcon, Text } from '@lmc/ui-kit'
import { lowerCase, trimEnd } from 'lodash'
import styled from 'styled-components'

export default function RoundsReportEmptyState(props: {
  preferredPeopleNominative: string
  residents: Array<{ id: string }>
}) {
  const { preferredPeopleNominative, residents } = props

  const helpLink =
    'https://support.logmycare.co.uk/en/articles/4851795-how-do-i-add-a-medication'
  const preferredResidentTerm = lowerCase(
    trimEnd(preferredPeopleNominative, 's')
  )

  const residentMARLink =
    residents && residents.length
      ? `/residents/${residents[0].id}/emar`
      : '/residents'

  return (
    <Wrapper>
      <EmptyState icon={<NoDataIcon />} title="No medications set up">
        <div>
          <StyledDescription>
            To know what medication have been administered or not administered,
          </StyledDescription>
          <StyledDescription>
            you’ll need to add a medication onto a {preferredResidentTerm}’s
            MAR.
          </StyledDescription>
          <StyledDescription>
            <a href={residentMARLink} target="_blank" rel="noreferrer">
              Go to a {preferredResidentTerm}'s MAR &gt;
            </a>
          </StyledDescription>
        </div>
        <StyledDescription>
          Learn more about adding medications{' '}
          <a href={helpLink} target="_blank" rel="noreferrer">
            here
          </a>
          .
        </StyledDescription>
      </EmptyState>
    </Wrapper>
  )
}

const StyledDescription = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  display: block;
`

const Wrapper = styled.div`
  margin-top: 16px;
`
